<ng-container [formGroup]="formGroup">
  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.storeNumber' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="storeNumber">
    <mat-error *ngIf="formGroup.get('storeNumber')?.errors && formGroup.get('storeNumber')?.touched">
      {{ 'pages.restaurantAccount.maxLengthNumberValidation' | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
